export const GMAIL_CONNECT_RETURN_PATH = "/integrations/gmail/connect";
export const DEFAULT_AUTHENTICATED_PATH = "/app/calendar/:calendarId/:suggestionId";
export const SETTINGS_PATH = "/app/settings/:userId";

export interface ISafeReturnState {
  returnTo: string;
}

/**
 * Authentication return locations are deliberately allowlisted.  Do not turn
 * this into a generic "relative URL" validator: a narrower list makes it much
 * harder for an encoded/protocol-relative value to become an open redirect in
 * a future router change.
 */
export function getSafeReturnPath(state: any): string | undefined {
  if (!state || typeof state.returnTo !== "string") {
    return;
  }

  return state.returnTo === GMAIL_CONNECT_RETURN_PATH
    ? GMAIL_CONNECT_RETURN_PATH
    : undefined;
}

export function gmailConnectLoginState(): ISafeReturnState {
  return { returnTo: GMAIL_CONNECT_RETURN_PATH };
}



// WEBPACK FOOTER //
// ./src/router/safeReturn.ts